import baseTheme from '../common/base-theme';
import type { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { YewCustomizations } from '../templates-info';

const yewTheme = (customizations: YewCustomizations): ResumeTheme => {
  const calcSize = getCalcSize(customizations.baseSize);
  const theme = {
    ...baseTheme,
    baseSize: customizations.baseSize,
    print: {
      ...baseTheme.print,
      backgroundColor: customizations.background,
      paddingX: calcSize(7.5, 98, 120),
      paddingY: calcSize(3.75, 40, 60),
    },
    web: { ...baseTheme.web, backgroundColor: customizations.background },
    fonts: {
      body: 'Lora, sans-serif',
      heading: 'Lora, sans-serif',
    },
    fontSizes: [12, 14, 16, 26],
    colors: {
      primaryText: customizations.text1,
      secondaryText: customizations.text2,
      tertiaryText: customizations.text3,
      skillsColor: customizations.accent1,
      background: customizations.background,
    },
    fontWeights: {
      body: 400,
      heading: 700,
      bold: 700,
    },
    lineHeights: {
      body: 1.5,
      heading: 1,
    },
    letterSpacings: {
      body: 'normal',
      caps: '1.2px',
    },
    text: {
      // Base text styles. Inherited by everything else.
      heading: {
        fontFamily: 'heading',
        lineHeight: 'heading',
        fontWeight: 'heading',
        textTransform: 'uppercase',
        color: 'primaryText',
      },
      body: {
        fontFamily: 'body',
        lineHeight: 'body',
        fontWeight: 'body',
        color: 'primaryText',
        fontSize: 1,
      },
      // Resume text elements
      resumeHeading: {
        variant: 'text.heading',
        fontSize: 3,
        letterSpacing: '1.3px',
        marginBottom: calcSize(1.5),
      },
      sectionHeading: {
        variant: 'text.heading',
        fontSize: 0,
        letterSpacing: '1.2px',
        textTransform: 'uppercase',
        color: 'tertiaryText',
        marginBottom: calcSize(1.5),
      },
      sectionItemHeading: {
        variant: 'text.heading',
        fontSize: 2,
        lineHeight: '24px',
        letterSpacing: '0.07em',
        marginBottom: calcSize(0.25),
      },
      sectionItemSubHeading: {
        color: 'secondaryText',
        fontSize: 1,
        lineHeight: '24px',
        marginBottom: calcSize(0.25),
        fontFamily: 'body',
      },
      paragraph: {
        variant: 'text.body',
        marginBottom: calcSize(0.25),
      },
      listItem: {
        variant: 'text.body',
        marginBottom: calcSize(0.25),
      },
      summaryListItem: {
        variant: 'text.listItem',
        marginLeft: 30,
        paddingLeft: 0,
      },
    },
    // Containers used to add margin bottom
    headerContainer: {
      marginBottom: calcSize(2),
    },
    sectionContainer: {
      marginBottom: calcSize(2.5),
    },
    detailSectionItemContainer: {
      marginBottom: calcSize(1.5),
    },
    blockListSectionItemContainer: {
      marginBottom: calcSize(1.25),
    },
    summaryList: {
      padding: 0,
    },
  };
  return theme;
};

export default yewTheme;
